export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Course Catalog"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Library"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profile"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log In"])}
        }
      },
      "ru": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Каталог курсов"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Библиотека"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Профиль"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Войти"])}
        }
      },
      "es": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catálogo de cursos"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biblioteca"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perfil"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar sesión"])}
        }
      },
      "kk": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курстар каталогы"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кітапхана"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Профиль"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кіру"])}
        }
      },
      "uz": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurslar katalogi"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kutubxona"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profil"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirish"])}
        }
      },
      "de": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurskatalog"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bibliothek"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profil"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])}
        }
      },
      "fr": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catalogue de cours"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bibliothèque"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profil"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se connecter"])}
        }
      },
      "it": {
        "menu": {
          "catalogCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catalogo dei corsi"])},
          "library": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biblioteca"])},
          "chat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
          "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profilo"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accedi"])}
        }
      }
    }
  })
}
